module.exports = __webpack_public_path__ + "img/player-marketplace.95ed0cd3.png";